import React from 'react';
import { Navbar } from './Navbar';
import { BottomNav } from './BottomNav';

interface LayoutProps {
  children: React.ReactNode;
  showBottomNav?: boolean;
}

export const Layout: React.FC<LayoutProps> = ({ children, showBottomNav = true }) => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <main className={`${showBottomNav ? 'pb-20' : 'pb-4'}`}>
        {children}
      </main>
      {showBottomNav && <BottomNav />}
    </div>
  );
};